import type { StepperDesignTokens } from '@primeuix/themes/types/stepper'

export default {
  root: {
    transitionDuration: '{transition.duration}',
  },
  step: {
    gap: '1rem',
    padding: '0.5rem',
  },
  separator: {
    size: '2px',
    margin: '0 0 0 1.625rem',
    background: '{content.border.color}',
    activeBackground: '{primary.color}',
  },
  stepTitle: {
    color: '{text.muted.color}',
    fontWeight: '500',
    activeColor: '{primary.color}',
  },
  steppanel: {
    color: '{content.color}',
    indent: '1rem',
    padding: '0',
    background: '{content.background}',
  },
  stepHeader: {
    gap: '0.5rem',
    padding: '0',
    focusRing: {
      color: '{focus.ring.color}',
      style: '{focus.ring.style}',
      width: '{focus.ring.width}',
      offset: '{focus.ring.offset}',
      shadow: '{focus.ring.shadow}',
    },
    borderRadius: '{content.border.radius}',
  },
  stepNumber: {
    size: '2.25rem',
    color: '{text.muted.color}',
    shadow: 'none',
    fontSize: '1.125rem',
    background: '{content.background}',
    fontWeight: '500',
    activeColor: '{surface.0}',
    borderColor: '{content.border.color}',
    borderRadius: '50%',
    activeBackground: '{primary.500}',
    activeBorderColor: '{surface.0}',
  },
  steppanels: {
    padding: '0.875rem 0.5rem 1.125rem 0.5rem',
  },
} satisfies StepperDesignTokens
